import { render, staticRenderFns } from "./transferPage.vue?vue&type=template&id=074c50a1&scoped=true&"
import script from "./transferPage.vue?vue&type=script&lang=js&"
export * from "./transferPage.vue?vue&type=script&lang=js&"
import style0 from "./transferPage.vue?vue&type=style&index=0&id=074c50a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074c50a1",
  null
  
)

export default component.exports